/**
 * The type of XR session.
 */
export enum XRSessionMode {
  None,
  AR,
  VR
}
